module.exports = __webpack_public_path__ + "img/ma200.599882dc.png";